import { useState } from "react";
import { ElectricitySupplierOffer } from "types";
import { triggerHandler } from "utils/events";
import theme from './ElectricitySupplier.module.scss';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Thumbnail } from "@ygtechnologies/bygr-frontend-component-library";
import ReorderableList from "components/ReordarableList/ReorderableList";
import { getOfferLogo, updateElectricitySupplierOffers } from "services/serviceProvider";


interface ElectricitySupplierReorderDialogProps {
    offers: ElectricitySupplierOffer[];
    show: boolean;
    onClose(): void;
    onAccept(): void;
}

const ElectricitySupplierReorderDialog: React.FC<ElectricitySupplierReorderDialogProps> = ({
    offers,
    show,
    onClose,
    onAccept
}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [sortedOffers, setSortedOffers] = useState<ElectricitySupplierOffer[]>([]);

    const handleOpen = () => {
        setSortedOffers(offers.sort((a,b) => a.sortOrder - b.sortOrder));
    };

    const handleClose = () => {
        triggerHandler(onClose);
    };
    
    const handleSubmit = async () => {
        setIsSaving(true);

        try {
            await updateElectricitySupplierOffers(orderItems(sortedOffers));

            triggerHandler(onAccept);
            triggerHandler(onClose);
        } finally {
            setIsSaving(false);
        }
    }

    const orderItems = (itemsToOrder: ElectricitySupplierOffer[]) => {
        for (let i = 0; i < itemsToOrder.length; i++) {
            itemsToOrder[i].sortOrder = i + 1;
        }

        return itemsToOrder;
    }

    const renderItem = (offer: ElectricitySupplierOffer) => {
        return (
            <div className={theme.item}>
                <div className={theme.thumbnail}>
                    <Thumbnail draggable={false} src={getOfferLogo(offer.logoId)} />
                </div>

                <div className={theme.offerName}>
                    <strong>{offer.highlightedTitle1}</strong>
                </div>

                <div className={theme.supplier}>
                    <strong>{offer.supplier}</strong>
                </div>
            </div>
        );
    }

    return(
        <Modal size="lg" onClose={handleClose} isOpen={show} onOpen={handleOpen}>
            <ModalHeader>Reorder offers</ModalHeader>
            <ModalBody>
                {sortedOffers && <ReorderableList data={sortedOffers} onChange={setSortedOffers} renderer={renderItem} />}
            </ModalBody>
            <ModalFooter>
                <Button color="tertiary" onClick={handleClose} disabled={isSaving}>
                    Cancel
                </Button>
                <Button type="submit" color="primary" loading={isSaving} onClick={handleSubmit}>
                    Save
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default ElectricitySupplierReorderDialog;